/**
 * User-related constants for the admin UI
 */

/**
 * Fiscal Year End options
 * @description Static list of months for fiscal year end selection
 */
export const FISCAL_YEAR_END_OPTIONS = [
  { value: 'january', label: 'January' },
  { value: 'february', label: 'February' },
  { value: 'march', label: 'March' },
  { value: 'april', label: 'April' },
  { value: 'may', label: 'May' },
  { value: 'june', label: 'June' },
  { value: 'july', label: 'July' },
  { value: 'august', label: 'August' },
  { value: 'september', label: 'September' },
  { value: 'october', label: 'October' },
  { value: 'november', label: 'November' },
  { value: 'december', label: 'December' },
] as const;

/**
 * Type for select option
 */
export interface SelectOption {
  value: string;
  label: string;
}
